import { ReactNode } from 'react';
import { Box } from '@mui/material';
import Tooltip from '../../../tooltip';
import { capitalize } from '../../../../../constants/helpers/utils';
import { Report } from '../../interfaces';

interface Props {
  children: ReactNode;
  tooltip: string;
  onClick: (item: Report) => void;
  item: Report;
}

const TableActionTrigger = ({ children, tooltip, onClick, item }: Props) => {
  const handleClick = () => {
    onClick(item);
  };
  return (
    <Tooltip title={capitalize(tooltip)}>
      <Box onClick={handleClick} display="flex" mr={1}>
        {children}
      </Box>
    </Tooltip>
  );
};

export default TableActionTrigger;
